import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function ScrollToTopOnRoute() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a0a] text-white">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <ScrollToTopOnRoute />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(57,255,20,0.35)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
